<ngx-slick-carousel
  class="carousel"
  #slickModal="slick-carousel"
  [config]="carouselConfig"
>
  @for (testimonial of testimonialsArray(); track testimonial) {
  <div ngxSlickItem class="slide">
    <app-testimonial-card
      [testimonialConfig]="testimonial"
    ></app-testimonial-card>
  </div>
  }
</ngx-slick-carousel>
